export default "__VITE_ASSET__Cvi3fTjy__"